import React, { useState } from "react";
import { ChevronDown, Search } from "lucide-react";

const faqs = [
  { q: "Do guests need to download an app?", a: "No. Guests scan your QR code or open your private link in their browser \u2014 no app or sign-up required." },
  { q: "What can guests upload?", a: "Photos, videos, and guestbook messages. You can choose which content types are enabled." },
  { q: "How long is my gallery active?", a: "This depends on your plan \u2014 typically 7, 30 or 90 days. Long-term hosting is available too." },
  { q: "Can I download photos in original resolution?", a: "Yes! You can download everything in full resolution at any time." },
  { q: "Is my gallery private?", a: "Absolutely. Galleries are private by default and only accessible via your unique link or QR code." },
  { q: "Can I moderate uploads?", a: "Yes. Hosts can review and approve uploads before they appear in the public gallery view." },
  { q: "What if I need help during my event?", a: "We offer live chat support and a comprehensive Help Center with setup videos and tips." }
];

const HelpCenter = () => {
  const [open, setOpen] = useState(0);
  const [search, setSearch] = useState("");
  const filtered = faqs.filter(f => f.q.toLowerCase().includes(search.toLowerCase()));

  return (
    <section className="section bg-cream-100">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-10">
          <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">Help Center</p>
          <h1 className="font-serif text-navy-700 text-5xl md:text-6xl mt-3">How can we <span className="italic">help?</span></h1>
        </div>
        <div className="relative mb-10">
          <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-navy-700/40" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search articles..." className="w-full pl-12 pr-4 py-4 rounded-full border border-cream-200 bg-white focus:outline-none focus:border-coral-300" />
        </div>
        <div className="space-y-3">
          {filtered.map((f, i) => (
            <div key={f.q} className="bg-white rounded-2xl border border-cream-200 overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left">
                <span className="font-semibold text-navy-700">{f.q}</span>
                <ChevronDown className={`w-5 h-5 text-coral-300 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && (
                <div className="px-6 pb-5 text-navy-700/75 leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HelpCenter;
